import type { ReactNode } from 'react'
import { ConfigProvider, App as AntApp } from 'antd'
import jaJP from 'antd/locale/ja_JP'
import { getEnvTheme } from '@/config/envTheme'

const theme = {
  token: {
    colorPrimary: getEnvTheme().primaryHex,
    borderRadius: 8,
    fontFamily: 'inherit',
  },
}

export function AntdProvider({ children }: { children: ReactNode }) {
  return (
    <ConfigProvider theme={theme} locale={jaJP}>
      <AntApp>{children}</AntApp>
    </ConfigProvider>
  )
}
